import { render, staticRenderFns } from "./MainContent.vue?vue&type=template&id=bf05ead6"
import script from "./MainContent.vue?vue&type=script&lang=ts"
export * from "./MainContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports